import { render, staticRenderFns } from "./titleDom.vue?vue&type=template&id=84e494e2&scoped=true&"
import script from "./titleDom.vue?vue&type=script&lang=js&"
export * from "./titleDom.vue?vue&type=script&lang=js&"
import style0 from "./titleDom.vue?vue&type=style&index=0&id=84e494e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e494e2",
  null
  
)

export default component.exports